import { useCollectionContext } from '@wix/bex-core/react';
import { Button } from '@wix/design-system';
import React, { MouseEvent as ReactMouseEvent, ReactNode } from 'react';

export interface PremiumButtonProps {
  /**
   * Callback for "Upgrade" button click.
   */
  onPremiumBtnClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
  /**
   * Text for "Upgrade" button
   */
  premiumBtnText?: ReactNode;
}
export function PremiumButton(props: PremiumButtonProps) {
  const state = useCollectionContext();
  const { translate: t } = state;
  const { premiumBtnText, onPremiumBtnClick } = props;

  return (
    <Button
      skin="premium"
      onClick={onPremiumBtnClick}
      dataHook="empty-state-premium-button"
    >
      {premiumBtnText ?? t('cairo.emptyState.premium.cta')}
    </Button>
  );
}
